import useTheme from "../../../../common/hooks/useTheme";
import { MouseEventHandler, ReactNode, useState } from "react";

const RoundedIconContainer = ({
  children,
  handleClick,
  isDisabled = false,
}: {
  children: ReactNode;
  handleClick: MouseEventHandler<HTMLDivElement>;
  isDisabled?: boolean;
}) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={styles.iconContainer(theme, isHovered, !isDisabled)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {children}
    </div>
  );
};

export default RoundedIconContainer;

const styles = {
  iconContainer: (theme: any, hover: boolean, active: boolean) => ({
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: active && hover ? theme.colorTokens.N[30] : "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    cursor: active ? "pointer" : "not-allowed",
  }),
};
